import { Brick, registerBrick, ErrorFlow } from 'olympe';
import { getLogger } from '@olympeio/core';
import { getAsArray } from '../../helper';
import * as _ from 'lodash';

export default class Initial extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} source
     * @param {function(*)} setResult
     * @param {function(*)} setErrorFlow
     */
    update($, [source], [setResult, setErrorFlow]) {
        const logger = getLogger('Initial');

        const { array, error } = getAsArray(source);

        if (!error) {
            const result = _.initial(array);
            setResult(result);
        } else {
            logger.error(error.message);
            setErrorFlow(ErrorFlow.create(error.message, error.code));
        }
    }
}

registerBrick('017fe3d7011546e41889', Initial);